(function () {
  'use strict';

  if (window.sgProductScrollStory) {
    window.sgProductScrollStory.init(document);
    return;
  }

  var rootSelector = '.sg-scroll-story[data-sg-story]';
  var rowSelector = '[data-sg-story-row]';
  var seenRows = new WeakSet();
  var waitingRows = new Set();
  var animations = new Map();
  var videos = new Map();
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var easing = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  var observer = null;

  function prefersReducedMotion() {
    return motionQuery && motionQuery.matches;
  }

  function play(element, frames, duration) {
    if (!element || typeof element.animate !== 'function' || prefersReducedMotion()) return;
    try {
      /* No fill mode: base CSS stays visible even if this animation is cancelled. */
      var animation = element.animate(frames, { duration: duration, easing: easing });
      animations.set(animation, element);
      if (animation.finished && typeof animation.finished.then === 'function') {
        animation.finished.then(function () {
          animations.delete(animation);
        }, function () {
          animations.delete(animation);
        });
      } else {
        animation.onfinish = function () { animations.delete(animation); };
        animation.oncancel = function () { animations.delete(animation); };
      }
    } catch (error) {
      /* An unsupported animation must never hide or block the product content. */
    }
  }

  function reveal(row) {
    if (row.getAttribute('data-sg-story-revealed') === 'true') return;
    waitingRows.delete(row);
    if (observer) observer.unobserve(row);
    row.setAttribute('data-sg-story-revealed', 'true');
    if (!row.isConnected || prefersReducedMotion()) return;

    var media = row.querySelector('[data-sg-story-media]');
    var copy = row.querySelector('[data-sg-story-copy]');
    var rtl = window.getComputedStyle(row).direction === 'rtl';
    var offset = rtl ? 20 : -20;

    if (media && window.innerWidth >= 768) {
      var rowBounds = row.getBoundingClientRect();
      var mediaBounds = media.getBoundingClientRect();
      offset = mediaBounds.left + mediaBounds.width / 2 < rowBounds.left + rowBounds.width / 2 ? -36 : 36;
    }

    play(media, [
      { opacity: 0.5, transform: 'translate3d(' + offset + 'px,0,0)' },
      { opacity: 1, transform: 'translate3d(0,0,0)' }
    ], 760);

    play(copy, [
      { opacity: 0.7, transform: 'translate3d(0,12px,0)', offset: 0 },
      { opacity: 0.7, transform: 'translate3d(0,12px,0)', offset: 0.12 },
      { opacity: 1, transform: 'translate3d(0,0,0)', offset: 1 }
    ], 630);
  }

  function getObserver() {
    if (observer) return observer;
    if (!('IntersectionObserver' in window) || prefersReducedMotion()) return null;
    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    } catch (error) {
      observer = null;
    }
    return observer;
  }

  function initVideos(root) {
    root.querySelectorAll('video[data-sg-story-video]').forEach(function (video) {
      if (videos.has(video)) return;
      var media = video.closest('[data-sg-story-media]');
      var button = media && media.querySelector('[data-sg-story-play]');
      if (!button || typeof video.play !== 'function') return;

      function showPlay() { button.hidden = false; }
      function hidePlay() {
        if (document.activeElement === button && typeof video.focus === 'function') {
          video.focus({ preventScroll: true });
        }
        button.hidden = true;
      }
      function playVideo() {
        try {
          var request = video.play();
          if (request && typeof request.catch === 'function') request.catch(showPlay);
        } catch (error) {
          showPlay();
        }
      }

      button.addEventListener('click', playVideo);
      video.addEventListener('play', hidePlay);
      video.addEventListener('pause', showPlay);
      video.addEventListener('ended', showPlay);
      video.addEventListener('error', showPlay);
      button.hidden = !video.paused && !video.ended;
      videos.set(video, function () {
        button.removeEventListener('click', playVideo);
        video.removeEventListener('play', hidePlay);
        video.removeEventListener('pause', showPlay);
        video.removeEventListener('ended', showPlay);
        video.removeEventListener('error', showPlay);
        button.hidden = true;
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    var roots = [];
    if (scope.matches && scope.matches(rootSelector)) roots.push(scope);
    if (scope.querySelectorAll) {
      Array.prototype.push.apply(roots, scope.querySelectorAll(rootSelector));
    }
    roots.forEach(function (root) {
      initVideos(root);
      root.querySelectorAll(rowSelector).forEach(function (row) {
        if (seenRows.has(row)) return;
        seenRows.add(row);
        if (prefersReducedMotion() || typeof row.animate !== 'function') {
          row.setAttribute('data-sg-story-revealed', 'true');
          return;
        }
        var activeObserver = getObserver();
        if (!activeObserver) {
          row.setAttribute('data-sg-story-revealed', 'true');
          return;
        }
        waitingRows.add(row);
        try {
          activeObserver.observe(row);
        } catch (error) {
          waitingRows.delete(row);
          row.setAttribute('data-sg-story-revealed', 'true');
        }
      });
    });
  }

  function cancelAnimations(scope) {
    animations.forEach(function (element, animation) {
      if (!scope || scope === element || scope.contains(element)) {
        animation.cancel();
        animations.delete(animation);
      }
    });
  }

  function onMotionChange() {
    if (!prefersReducedMotion()) return;
    cancelAnimations();
    waitingRows.forEach(function (row) {
      if (observer) observer.unobserve(row);
      row.setAttribute('data-sg-story-revealed', 'true');
    });
    waitingRows.clear();
  }

  window.sgProductScrollStory = { init: init, version: '1.0.0' };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    waitingRows.forEach(function (row) {
      if (section.contains(row)) {
        if (observer) observer.unobserve(row);
        waitingRows.delete(row);
      }
    });
    cancelAnimations(section);
    videos.forEach(function (cleanup, video) {
      if (section.contains(video)) {
        cleanup();
        videos.delete(video);
      }
    });
  });

  if (motionQuery) {
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
    else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
  }
})();
